module.exports = __webpack_public_path__ + "static/lightning-file-f2529b1c5848d956cd33cc2905f287f0.png";